/**
 * Product form: require an explicit size/variant choice before treating inventory as final.
 * - Shopify often opens the product URL with ?variant=<first available>; we treat that as “no choice yet”
 *   and ignore it unless ?variant= points at a different variant (real deep link).
 * - ATC shows “Select a size” until the shopper picks a variant; sold-out / add-to-bag only after that.
 */
(function () {
  'use strict';

  function selectSizeMessage() {
    return (
      (window.PXUTheme &&
        window.PXUTheme.translation &&
        window.PXUTheme.translation.select_size_text) ||
      'Select a size'
    );
  }

  function stripVariantSearchParam() {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('variant')) return;
      url.searchParams.delete('variant');
      var qs = url.searchParams.toString();
      window.history.replaceState({}, document.title, url.pathname + (qs ? '?' + qs : '') + url.hash);
    } catch (e) {
      /* IE or restricted environments */
    }
  }

  function shouldDeferVariantFromUrl(wrapper) {
    var variantParam = window.Shopify.urlParam('variant');
    if (!variantParam) return true;

    var implicitId = wrapper.getAttribute('data-implicit-default-variant-id');
    if (!implicitId) return false;

    return String(variantParam) === String(implicitId);
  }

  if (typeof window.Shopify !== 'undefined' && window.Shopify.OptionSelectors) {
    var originalInitDropdown = window.Shopify.OptionSelectors.prototype.initDropdown;

    window.Shopify.OptionSelectors.prototype.initDropdown = function () {
      var opts = { initialLoad: true };
      var hidden = document.getElementById(this.domIdPrefix);
      var wrapper = hidden && hidden.closest('[data-product-form]');
      var skipAutoSelect =
        wrapper &&
        wrapper.classList.contains('product_form_options') &&
        shouldDeferVariantFromUrl(wrapper);

      if (skipAutoSelect) {
        var self = this;

        setTimeout(function () {
          if (window.Shopify.urlParam('variant')) {
            stripVariantSearchParam();
          }
          if (self.selectVariantFromParams(opts)) {
            return;
          }
          self.variantIdField.value = '';
          self.variantIdField.disabled = true;
          if (window.jQuery) {
            window.jQuery(wrapper).data('user-chose-options', false);
          }
          self.onVariantSelected(null, self, opts);
        });
        return;
      }

      return originalInitDropdown.call(this);
    };
  }

  if (typeof window.selectCallback === 'function') {
    var originalSelectCallback = window.selectCallback;

    window.selectCallback = function (variant, selector, $element) {
      originalSelectCallback(variant, selector, $element);

      var $ = window.jQuery;
      if (!$) {
        return;
      }

      var $product;
      if ($element) {
        $product = $element.find('.product-' + selector.product.id);
      } else {
        $product = $('.product-' + selector.product.id);
      }

      var $productForm = $('.product_form, .shopify-product-form', $product);
      if (!$productForm.hasClass('product_form_options')) {
        return;
      }

      var userChose = $productForm.data('user-chose-options');
      var msg = selectSizeMessage();

      if (!variant && !userChose) {
        $product.find('.purchase-details__buttons').removeClass('product-is-unavailable');
        $product.find('.modal_price').removeClass('variant-unavailable');
        $product.find('.sold_out').text('');
        $product.find('.shopify-payment-button').addClass('disabled');
        $product.find('.btn--full.klaviyo-bis-trigger').addClass('hidden').removeClass('visible');

        var $notify = $product.find('.notify-form-' + selector.product.id);
        $notify.hide();
        $notify.find('.notify_form__inputs').empty();

        $product.find('#dummy_button').removeClass('hide').removeAttr('disabled').removeClass('disabled')
          .find('.text').text(msg);
        $product.find('#main_button').addClass('hide').attr('disabled', 'disabled').addClass('disabled')
          .find('.text').text(msg);

        $('#preview_button_size').removeClass('hide');
        $('#main_button_size').addClass('hide');
      }
    };
  }

  function bindUserChoiceTracking($) {
    $('body').on(
      'change',
      '.product_form_options .single-option-selector',
      function () {
        $(this).closest('[data-product-form]').data('user-chose-options', true);
      }
    );
    $('body').on(
      'change',
      '.product_form_options .swatch input[type="radio"]',
      function () {
        $(this).closest('[data-product-form]').data('user-chose-options', true);
      }
    );
  }

  if (window.jQuery) {
    window.jQuery(function () {
      bindUserChoiceTracking(window.jQuery);
    });
  }
})();
